import dayjs from "dayjs";
import { Notification } from "@/fetch/notifications";
import useNotificationAction, {
  NotificationTypes,
} from "./useNotificationAction";

const useNotificationGroup = (
  notifications: Array<Notification>,
  type: NotificationTypes | "All"
) => {
  const { translateNotification } = useNotificationAction();
  const relatedTypeNotifications =
    type === "All"
      ? notifications
      : notifications.filter((each) => {
          const { type: notificationType } = translateNotification(each);
          return notificationType === type;
        });

  const sevenDaysAgo = dayjs().subtract(7, "day");

  const lastSevenDaysNotifications = relatedTypeNotifications.filter(
    (each) => !dayjs(each.createdAt).isBefore(sevenDaysAgo)
  );
  const restNotifications = relatedTypeNotifications.filter((each) =>
    dayjs(each.createdAt).isBefore(sevenDaysAgo)
  );
  return { lastSevenDaysNotifications, restNotifications };
};

export default useNotificationGroup;
